export default "__VITE_ASSET__CT$_EtbM__"